import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Item class to inform that the item should display a corner radius editor
 * @param {LayoutItem} Item The item to enhance
 */
export const withShowCornerRadiusEditor: PresetHOC<{
    showCornerRadiusEditor?: boolean;
}> = (Item) => {
    Item.showCornerRadiusEditor = true;

    return Item;
};
